<template>
  <div>
    <transition name="fade">
      <div class="input-source__osd" v-if="showOSD">
        <div class="osd__header">
          <div class="osd-back" :class="{ 'osd-back--active': isBackActive }">
            <Icon color="#f1f1f1">
              <ArrowLeft></ArrowLeft>
            </Icon>
            {{ getBack }}
          </div>
          <div class="tv-osd__header-title">{{ headline }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import ArrowLeft from '@/assets/icons/WayfinderArrowLeft.vue';
import { KEYS } from '@/mixins/keyHandler';

export default {
  components: {
    Icon,
    ArrowLeft,
  },
  props: {
    isShowOsd: {
      default: false,
      type: Boolean,
    },
    headline: {
      type: String,
    },
    isBackActive: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['hide'],
  mounted() {
    this.$eventBus.$on('key-action', (context) => {
      if (context.key === KEYS.UP) {
        this.fadeOutTimer = 0;
      }
    });
    this.showOSD = true;
    this.handleOSDFadeInOut();
  },
  emits: {},
  data() {
    return {
      fadeOutTimer: 0,
      osdInterval: null,
      showOSD: false,
    };
  },
  watch: {
    isShowOsd(isTrue) {
      console.log('showOSD WATCHER', isTrue);
      if (isTrue) {
        this.showOSD = true;
        this.handleOSDFadeInOut();
      } else {
        this.fadeOutTimer = 5000;
      }
    },
    fadeOutTimer(value) {
      console.log('FADE OUT');
      if (value >= 5000) {
        // this.showOSD = false;
        clearInterval(this.osdInterval);
        this.fadeOutTimer = 0;
        this.$emit('hide');
        this.showOSD = false;
      }
    },
  },
  methods: {
    increaseFadeOutTimer() {
      this.fadeOutTimer += 1000;
    },
    handleOSDFadeInOut() {
      this.osdInterval = setInterval(this.increaseFadeOutTimer, 1000);
    },
  },
  computed: {
    getBack() {
      return this.$i18n('back.name');
    },
  },
  // created: function() {}
};
</script>

<style scoped>
.osd__header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.7),
    transparent 75%,
    transparent
  );
  color: white;
  display: flex;
  font-size: 3vw;
  justify-content: space-between;
  padding: 0 40px;
  height: 120px;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  width: 100vw;
}
.osd-back {
  font-size: 2vw;
  border: 2px solid transparent;
  padding: 10px 20px;
}
.osd-back--active {
  border-color: #f1f1f1;
}

.fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.fade-leave-active {
  transition: all 0.6s ease-in-out;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/OSDHeader.vue